import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiStar } from 'react-icons/fi';

const TestimonialsSection = () => {
  const { t } = useTranslation();

  const testimonials = t('landing.testimonials.items', { returnObjects: true });

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50" aria-label={t('landing.testimonialsSection.ariaLabel')}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-extrabold text-gray-900 dark:text-surface-50 mb-4" data-testid="testimonials-title">
            {t('landing.testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 dark:text-surface-400" data-testid="testimonials-subtitle">
            {t('landing.testimonials.subtitle')}
          </p>
        </div>
        {/* No schema.org/Review markup: reviews of our own product are not
            eligible for review snippets, and Search Console flagged them
            (missing itemReviewed). */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {Array.isArray(testimonials) && testimonials.map((testimonial, index) => (
            <article
              key={index}
              className="bg-white dark:bg-surface-900 rounded-xl shadow-lg p-8 hover:shadow-2xl transition duration-300"
              data-testid={`testimonial-card-${index}`}
            >
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <FiStar key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-600 dark:text-surface-400 mb-6 leading-relaxed italic">"{testimonial.content}"</p>
              <div className="border-t pt-4">
                <p className="font-bold text-gray-900 dark:text-surface-50">{testimonial.name}</p>
                <p className="text-sm text-gray-600 dark:text-surface-400">{testimonial.role}</p>
                <p className="text-sm text-blue-600 font-semibold">{testimonial.company}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
